var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"skuTable",attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.tableHeight,"size":"small","row-id":"amzSkuCode","seq-config":{ startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize },"radio-config":!_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            strict: false,
            reserve: _vm.reserve,
          }
        : {},"checkbox-config":_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            reserve: _vm.reserve,
          }
        : {},"resizable":"","border":""},on:{"radio-change":_vm.radioChange,"checkbox-change":_vm.checkboxChange,"checkbox-all":_vm.checkboxChange},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"status",fn:function(ref){
        var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.amzPurchaseStatus === 'N'
            ? 'primary'
            : row.amzPurchaseStatus === 'Y'
            ? 'success'
            : row.amzPurchaseStatus === 'D'
            ? 'danger'
            : 'warning'}},[_vm._v(" "+_vm._s(row.v_amzPurchaseStatus)+" ")])]}},{key:"totalAmount",fn:function(ref){
            var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.totalAmount + ' ' + (row.v_currencyUnit ? row.v_currencyUnit : '--')))])]}},{key:"empty",fn:function(ref){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"no-data"},[_vm._v(" "+_vm._s(_vm.$l('INDEX.tips_no_data') || '暂无数据！')+" ")])])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }